package org.example.project.ui

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import battleships.shared.generated.resources.*
import kotlinx.coroutines.delay
import org.example.project.model.*
import org.example.project.viewmodel.GameViewModel
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.example.project.model.ShipType
import androidx.compose.ui.zIndex
import androidx.lifecycle.viewmodel.compose.viewModel
import kotlinx.coroutines.delay
import org.example.project.model.BattlePhase
import org.example.project.util.currentTimeMillis
import kotlin.collections.emptyList

@Composable
fun BattleShipScreen(
    viewModel: GameViewModel
) {

    val game = viewModel.multiplayerGame ?: return

    val opponentMode =
        game.opponentTimerMode(viewModel.myUid)

    val opponentStart =
        game.opponentTimerStart(viewModel.myUid)
    val opponentRemaining by produceState(
        initialValue = 0,
        key1 = opponentMode,
        key2 = opponentStart
    ) {

        while (true) {

            val elapsed =
                ((currentTimeMillis() - opponentStart) / 1000).toInt()

            value =
                when (opponentMode) {

                    TimerMode.TURN ->
                        (60 - elapsed).coerceAtLeast(0)

                    TimerMode.QUESTION ->
                        (30 - elapsed).coerceAtLeast(0)

                    else ->
                        0
                }

            delay(1000)
        }
    }
    LaunchedEffect(
        viewModel.showExplosion
    )
    {
        if (viewModel.showExplosion) {

            delay(1000)
            viewModel.hideExplosion()
        }
    }
    if (viewModel.battlePhase == BattlePhase.QUESTION_ACTIVE && viewModel.currentQuestion != null
    ) {
        viewModel.timerMode= TimerMode.QUESTION
        QuestionDialog(question = viewModel.currentQuestion!!, viewModel) { answer ->
            val correct = viewModel.submitAnswer(answer)
            viewModel.onQuestionAnswered(correct)
        }
    }

    if (viewModel.showPenaltyDialog) {
        AlertDialog(
            onDismissRequest = {},
            title = { Text("COMMAND ERROR", color = Color.Red) },
            text = { Text("Fleet controls locked.\nRebooting systems...") },
            confirmButton = {}
        )
    }

    if (viewModel.showForfeitDialog) {

        AlertDialog(

            onDismissRequest = {
                viewModel.showForfeitDialog = false
            },

            title = { Text("FORFEIT MATCH", color = Color.Red) },
            text = { Text("Are you sure you want to surrender?\n\nYour opponent will immediately win.") },
            dismissButton = {
                OutlinedButton(
                    onClick = {
                        viewModel.showForfeitDialog = false
                    }
                ) {
                    Text("Cancel")
                }
            },
            confirmButton = {

                Button(
                    colors = ButtonDefaults.buttonColors(
                        containerColor = Color.Red
                    ),
                    onClick = {
                        viewModel.forfeit()
                    }
                ) {
                    Text("Forfeit")
                }
            }
        )
    }

    if (viewModel.showAttackConfirmation) {

        Dialog(
            onDismissRequest = {
                viewModel.cancelAttack()
            }
        ) {

            Surface(
                modifier = Modifier.width(420.dp),
                shape = RoundedCornerShape(18.dp),
                color = Color(0xFF071420),
                border = BorderStroke(
                    2.dp,
                    Color(0xFF00CFFF)
                ),
                shadowElevation = 20.dp
            ) {

                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(24.dp)
                ) {

                    Text(
                        text = "CONFIRM STRIKE",
                        color = Color(0xFF00CFFF),
                        fontWeight = FontWeight.Bold,
                        fontSize = 26.sp
                    )

                    Spacer(Modifier.height(6.dp))

                    HorizontalDivider(
                        color = Color(0xFF00CFFF)
                    )

                    Spacer(Modifier.height(20.dp))

                    Text(
                        "WEAPON",
                        color = Color.Gray,
                        fontWeight = FontWeight.Bold
                    )

                    Spacer(Modifier.height(4.dp))

                    Text(
                        viewModel.selectedAttackType.displayName,
                        color = Color.White,
                        fontSize = 20.sp
                    )

                    Spacer(Modifier.height(18.dp))

                    Text(
                        "TARGET",
                        color = Color.Gray,
                        fontWeight = FontWeight.Bold
                    )

                    Spacer(Modifier.height(4.dp))

                    Text(
                        "${('A' + viewModel.pendingAttackRow)}${viewModel.pendingAttackCol + 1}",
                        color = Color.White,
                        fontSize = 20.sp
                    )

                    Spacer(Modifier.height(18.dp))

                    Text(
                        "WARNING",
                        color = Color(0xFFFFA000),
                        fontWeight = FontWeight.Bold
                    )

                    Spacer(Modifier.height(4.dp))

                    Text(
                        "Once launched, this attack cannot be cancelled.",
                        color = Color.LightGray
                    )

                    Spacer(Modifier.height(28.dp))

                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(14.dp)
                    ) {

                        OutlinedButton(
                            modifier = Modifier.weight(1f),
                            border = BorderStroke(
                                1.dp,
                                Color(0xFF00CFFF)
                            ),
                            colors = ButtonDefaults.outlinedButtonColors(
                                contentColor = Color(0xFF00CFFF)
                            ),
                            onClick = {
                                viewModel.cancelAttack()
                            }
                        ) {

                            Text("ABORT")
                        }

                        Button(
                            modifier = Modifier.weight(1f),
                            colors = ButtonDefaults.buttonColors(
                                containerColor = Color(0xFFD32F2F)
                            ),
                            onClick = {
                                viewModel.confirmAttack()
                            }
                        ) {

                            Text(
                                "FIRE",
                                color = Color.White,
                                fontWeight = FontWeight.Bold
                            )
                        }
                    }
                }
            }
        }
    }

    LaunchedEffect(viewModel.showPenaltyDialog) {
        if (viewModel.showPenaltyDialog) {
            delay(5000)
            viewModel.endPenalty()
        }
    }

    BoxWithConstraints(
        modifier = Modifier.fillMaxSize()
    ) {

        val isMobile = maxWidth < 700.dp
        val isTablet = maxWidth in 700.dp..1000.dp

        val cellSize =
            when {
                isMobile -> 24.dp
                isTablet -> 30.dp
                else -> 35.dp
            }

        val titleSize =
            when {
                isMobile -> 30.sp
                else -> 42.sp
            }
        Image(
            painter = painterResource(Res.drawable.ocean),
            contentDescription = null,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )

        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.Black.copy(alpha = 0.4f))
        )

        Column(
            modifier = Modifier
                .fillMaxSize()
                .verticalScroll(rememberScrollState())
                .padding(
                    if (isMobile)
                        12.dp
                    else
                        24.dp
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = "BATTLESHIPS",
                style = MaterialTheme.typography.headlineLarge.copy(
                    fontWeight = FontWeight.ExtraBold,
                    letterSpacing = 4.sp
                ),
                color = Color.White
            )

            Spacer(Modifier.height(8.dp))

            TurnIndicator(viewModel)

            Spacer(Modifier.height(8.dp))

            EnemyTimerCard(
                opponentMode,
                opponentRemaining
            )

            if (viewModel.isMyTurn) {

                Spacer(Modifier.height(10.dp))

                CommandConsole(
                    viewModel = viewModel,
                    isMobile = isMobile
                )

                Spacer(Modifier.height(16.dp))
            }

            Surface(
                color = Color.Black.copy(alpha = 0.6f),
                shape = RoundedCornerShape(8.dp),
                border = BorderStroke(1.dp, Color(0xFF00CFFF).copy(alpha = 0.5f))
            ) {
                Text(
                    text = viewModel.statusMessage.uppercase(),
                    color = when {
                        viewModel.statusMessage.contains("Victory", ignoreCase = true) -> Color(
                            0xFF00FF00
                        )

                        viewModel.statusMessage.contains("Wrong", ignoreCase = true) -> Color(
                            0xFFFF4444
                        )

                        viewModel.isMyTurn -> Color(0xFF00CFFF)
                        else -> Color(0xFFFFAA00)
                    },
                    modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp),
                    style = MaterialTheme.typography.labelLarge,
                    textAlign = TextAlign.Center
                )
            }

            Spacer(Modifier.height(12.dp))

            if (isMobile) {

                Column(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(24.dp)
                ) {
                    BoardPanel(
                        title = "${viewModel.opponentName}'s WATERS",
                        board = viewModel.enemyBoard,
                        canAttack = viewModel.isMyTurn,
                        onCellClick = { row, col ->
                            viewModel.requestAttack(row, col)
                        },
                        showShips = false,
                        deployedShips = emptyList(),
                        viewModel = viewModel,
                        cellSize = cellSize,
                        isMobile = true,
                        showScanned = true
                    )

                    BoardPanel(
                        title = "${viewModel.playerName}'s WATERS",
                        board = viewModel.playerBoard,
                        canAttack = false,
                        onCellClick = { _, _ -> },
                        showShips = true,
                        deployedShips = viewModel.deployedShips,
                        viewModel = viewModel,
                        cellSize = cellSize,
                        isMobile = true,
                        showScanned = false
                    )

                    SidePanel(
                        score = viewModel.localScore,
                        penalties = viewModel.localPenalties,
                        correctAnswers = viewModel.localCorrect,
                        shipsRemaining = viewModel.remainingEnemyCells(),
                        charges = viewModel.myCharges,
                        selectedAttack = viewModel.selectedAttackType,
                        isMobile = true,
                        onForfeitClick = {
                            viewModel.showForfeitDialog = true
                        }
                    )
                }

            } else {

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement =
                        Arrangement.SpaceEvenly,
                    verticalAlignment =
                        Alignment.Top
                ) {
                    BoardPanel(
                        title = "${viewModel.opponentName} WATERS",
                        board = viewModel.enemyBoard,
                        canAttack = viewModel.isMyTurn,
                        onCellClick = { row, col ->
                            viewModel.requestAttack(
                                row,
                                col
                            )
                        },
                        showShips = false,
                        deployedShips = emptyList(),
                        viewModel = viewModel,
                        cellSize = cellSize,
                        isMobile = false,
                        showScanned = true
                    )

                    BoardPanel(
                        title = "${viewModel.playerName}'s WATERS",
                        board = viewModel.playerBoard,
                        canAttack = false,
                        onCellClick = { _, _ -> },
                        showShips = true,
                        deployedShips = viewModel.deployedShips,
                        viewModel = viewModel,
                        cellSize = cellSize,
                        isMobile = false,
                        showScanned = false
                    )

                    SidePanel(
                        score = viewModel.localScore,
                        penalties = viewModel.localPenalties,
                        correctAnswers = viewModel.localCorrect,
                        shipsRemaining = viewModel.remainingEnemyCells(),
                        charges = viewModel.myCharges,
                        selectedAttack = viewModel.selectedAttackType,
                        isMobile = false,
                        onForfeitClick = {
                            viewModel.showForfeitDialog = true
                        }
                    )
                }
            }
        }
    }
}

@Composable
private fun TurnIndicator(viewModel: GameViewModel) {
    val isMyTurn = viewModel.isMyTurn
    Surface(
        color = if (isMyTurn) Color(0xFF004400) else Color(0xFF440000),
        shape = RoundedCornerShape(20.dp),
        border = BorderStroke(
            2.dp,
            if (isMyTurn) Color(0xFF00FF00) else Color(0xFFFF4444)
        )
    ) {
        Text(
            text = if (isMyTurn) "YOUR TURN" else "${viewModel.opponentName}'s TURN",
            color = Color.White,
            fontWeight = FontWeight.Bold,
            modifier = Modifier.padding(horizontal = 24.dp, vertical = 8.dp)
        )
    }
}

@Composable
private fun CommandConsole(
    viewModel: GameViewModel,
    isMobile: Boolean
) {

    Surface(
        modifier = Modifier
            .fillMaxWidth(
                if (isMobile) 1f else 0.95f
            ),
        color = Color.Black.copy(alpha = 0.65f),
        border = BorderStroke(
            2.dp,
            Color(0xFF00CFFF)
        ),
        shape = RoundedCornerShape(16.dp),
        shadowElevation = 10.dp
    ) {

        if (isMobile) {

            Column(
                modifier = Modifier.padding(12.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                AttackTypeSelector(viewModel)
                Spacer(Modifier.height(14.dp))
                if (!viewModel.showQuestionDialog) {
                    MissionTimer(viewModel)
                }
            }

        } else {

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(16.dp),

                verticalAlignment = Alignment.CenterVertically,

                horizontalArrangement =
                    Arrangement.SpaceBetween
            ) {
                AttackTypeSelector(viewModel)
                Spacer(Modifier.width(24.dp))
                if (!viewModel.showQuestionDialog) {
                    MissionTimer(viewModel)
                }
            }
        }
    }
}

@Composable
private fun MissionTimer(
    viewModel: GameViewModel
) {
    val animatedColor by animateColorAsState(
        targetValue = when {

            viewModel.turnTimeRemaining <= 10 ->
                Color.Red

            viewModel.turnTimeRemaining <= 30 ->
                Color(0xFFFF9800)

            else ->
                Color(0xFF00FFFF)
        },

        animationSpec = tween(500)
    )

    val infiniteTransition =
        rememberInfiniteTransition()

    val scale by infiniteTransition.animateFloat(
        initialValue = 1f,
        targetValue =
            if (viewModel.turnTimeRemaining <= 10)
                1.12f
            else
                1.03f,

        animationSpec =
            infiniteRepeatable(
                tween(550),
                RepeatMode.Reverse
            )
    )

    Surface(
        modifier = Modifier.wrapContentSize(),
        color = Color(0xFF001B33),
        border = BorderStroke(
            2.dp,
            animatedColor
        ),
        shape = RoundedCornerShape(14.dp)
    ) {

        Column(
            modifier = Modifier.padding(
                horizontal = 20.dp,
                vertical = 14.dp
            ),
            horizontalAlignment =
                Alignment.CenterHorizontally
        ) {

            Text(
                "MISSION TIMER",
                color = Color.White,
                fontSize = 12.sp,
                fontWeight = FontWeight.Bold
            )

            Spacer(
                Modifier.height(6.dp)
            )

            Text(
                text = "${viewModel.formattedTime()}",
                modifier = Modifier.scale(scale),
                fontSize = 25.sp,
                fontWeight = FontWeight.ExtraBold,
                color = animatedColor
            )

            Spacer(
                Modifier.height(4.dp)
            )

            Text(
                text =
                    when {

                        viewModel.turnTimeRemaining <= 10 ->
                            "LAUNCH NOW"

                        viewModel.turnTimeRemaining <= 30 ->
                            "TIME RUNNING OUT"

                        else ->
                            "Awaiting Command"
                    },

                color = animatedColor.copy(alpha = 0.8f),
                fontSize = 11.sp
            )
        }
    }
}

@Composable
private fun AttackTypeSelector(
    viewModel: GameViewModel
) {
    Surface(
        modifier = Modifier.wrapContentHeight(),
        shape = RoundedCornerShape(14.dp),
        color = Color.Black.copy(alpha = 0.65f),
        border = BorderStroke(
            2.dp,
            Color(0xFF00CFFF)
        ),
        shadowElevation = 10.dp
    ) {

        Column(
            modifier = Modifier.padding(
                horizontal = 20.dp,
                vertical = 14.dp
            ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Text(
                text = "ARMAMENT",
                color = Color(0xFF00CFFF),
                fontWeight = FontWeight.Bold,
                fontSize = 13.sp,
                letterSpacing = 1.sp
            )

            Spacer(Modifier.height(5.dp))

            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(6.dp),
                verticalArrangement = Arrangement.spacedBy(6.dp)
            ) {

                AttackType.entries.forEach { type ->

                    val charges =
                        viewModel.myCharges.chargeFor(type)

                    val available =
                        viewModel.myCharges.canUse(type)

                    val selected =
                        viewModel.selectedAttackType == type

                    FilterChip(
                        selected = selected,
                        onClick = {
                            if (available)
                                viewModel.selectAttackType(type)
                        },
                        enabled = available,
                        label = {
                            Text(
                                text =
                                    if (type == AttackType.TORPEDO)
                                        type.displayName
                                    else
                                        "${type.displayName} ($charges)",
                                fontSize = 10.sp
                            )
                        },
                        border = FilterChipDefaults.filterChipBorder(
                            enabled = available,
                            selected = selected,
                            borderColor = Color(0xFF00CFFF),
                            selectedBorderColor = Color(0xFF00FFFF)
                        ),
                        colors = FilterChipDefaults.filterChipColors(
                            containerColor = Color(0xFF001B33),
                            selectedContainerColor = Color(0xFF006D91),
                            disabledContainerColor = Color(0xFF1A1A1A),
                            labelColor = Color.White,
                            selectedLabelColor = Color.White
                        )
                    )
                }
            }

            if (viewModel.selectedAttackType == AttackType.LINE_STRIKE) {

                Spacer(Modifier.height(6.dp))

                Row(
                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                ) {

                    FilterChip(
                        selected = viewModel.lineStrikeHorizontal,
                        onClick = {
                            if (!viewModel.lineStrikeHorizontal)
                                viewModel.toggleLineStrikeOrientation()
                        },
                        label = {
                            Text("ROW")
                        }
                    )

                    FilterChip(
                        selected = !viewModel.lineStrikeHorizontal,
                        onClick = {
                            if (viewModel.lineStrikeHorizontal)
                                viewModel.toggleLineStrikeOrientation()
                        },
                        label = {
                            Text("COLUMN")
                        }
                    )
                }
            }
        }
    }
}


@Composable
fun BoardPanel(
    title: String,
    board: Board,
    canAttack: Boolean,
    onCellClick: (Int, Int) -> Unit,
    showShips: Boolean,
    deployedShips: List<PlacedShip>,
    viewModel: GameViewModel,
    cellSize: Dp,
    isMobile: Boolean,
    showScanned: Boolean = false
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier
            .wrapContentWidth()
            .background(
                Color.Black.copy(alpha = 0.5f),
                RoundedCornerShape(8.dp)
            )
            .border(
                2.dp,
                Color(0xFF00CFFF),
                RoundedCornerShape(8.dp)
            )
            .padding(
                if (isMobile) 8.dp else 16.dp
            )
    ) {
        Text(
            text = title,
            color = Color(0xFF00CFFF),
            fontWeight = FontWeight.Bold,
            style = MaterialTheme.typography.titleMedium
        )
        Spacer(Modifier.height(8.dp))
        GridWithLabels(
            board = board,
            canAttack = canAttack,
            onCellClick = onCellClick,
            showShips = showShips,
            deployedShips = deployedShips,
            viewModel = viewModel,
            cellSize = cellSize,
            showScanned = showScanned
        )
    }
}

@Composable
fun GridWithLabels(
    board: Board,
    canAttack: Boolean,
    onCellClick: (Int, Int) -> Unit,
    showShips: Boolean,
    deployedShips: List<PlacedShip>,
    viewModel: GameViewModel,
    cellSize: Dp,
    showScanned: Boolean = false
) {
    val labelWidth = cellSize
    val boardWidth = cellSize * 11
    Column(
        modifier = Modifier.width(boardWidth),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Spacer(Modifier.size(labelWidth))
            for (i in 1..10) {
                Box(
                    modifier = Modifier.size(cellSize),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = i.toString(),
                        modifier = Modifier.width(cellSize),
                        color = Color(0xFF00CFFF).copy(alpha = 0.7f),
                        fontSize = when {
                            cellSize <= 24.dp -> 10.sp
                            else -> 12.sp
                        },
                        textAlign = TextAlign.Center
                    )
                }
            }
        }

        Spacer(Modifier.height(4.dp))

        for (row in 0 until 10) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    text = ('A' + row).toString(),
                    color = Color(0xFF00CFFF).copy(alpha = 0.7f),
                    modifier = Modifier.width(cellSize),
                    fontSize =
                        when {
                            cellSize <= 24.dp -> 10.sp
                            else -> 12.sp
                        },
                    textAlign = TextAlign.Center
                )

                repeat(10) { col ->
                    val ship = deployedShips.firstOrNull { s ->
                        (0 until s.type.size).any { i ->
                            val sr = if (s.horizontal) s.row else s.row + i
                            val sc = if (s.horizontal) s.col + i else s.col
                            sr == row && sc == col
                        }
                    }
                    val isShipStart = ship?.row == row && ship?.col == col
                    val cellState = board.cells[row][col]
                    val isClickable = canAttack &&
                            cellState != CellState.HIT &&
                            cellState != CellState.MISS

                    val bgColor by animateColorAsState(
                        when (cellState) {
                            CellState.HIT -> Color(0xFFFF4444).copy(alpha = 0.6f)
                            CellState.MISS -> Color(0xFFFFFFFF).copy(alpha = 0.2f)
                            CellState.SHIP -> if (showShips) Color(0xFF42B5FF)
                            else if (showScanned) Color(0xFF886600).copy(alpha = 0.7f)
                            else Color(0xFF021C2E).copy(alpha = 0.75f)

                            CellState.EMPTY -> if (canAttack) Color(0xFF033E63)
                            else Color(0xFF021C2E).copy(alpha = 0.75f)
                        }
                    )

                    Box(
                        modifier = Modifier
                            .size(cellSize)
                            .padding(0.5.dp)
                            .background(bgColor)
                            .border(0.5.dp, Color(0xFF00CFFF).copy(alpha = 0.3f))
                            .clickable(enabled = isClickable) { onCellClick(row, col) },
                        contentAlignment = Alignment.Center
                    ) {
                        if (showShips && isShipStart && ship != null) {
                            val image = shipImageFor(ship.type)
                            Image(
                                painter = painterResource(image),
                                contentDescription = null,
                                modifier =
                                    Modifier
                                        .zIndex(10f)
                                        .width(if (ship.horizontal) cellSize * ship.type.size else cellSize)
                                        .height(if (ship.horizontal) cellSize else cellSize * ship.type.size),
                                contentScale = ContentScale.FillBounds
                            )
                        }

                        if (viewModel.showExplosion &&
                            viewModel.explosionRow == row &&
                            viewModel.explosionCol == col
                        ) {
                            Text("💥", fontSize = 24.sp)
                        }
                        when (cellState) {
                            CellState.HIT -> Box(
                                Modifier.size(10.dp).clip(CircleShape).background(Color.Red)
                            )

                            CellState.MISS -> Box(
                                Modifier.size(6.dp).clip(CircleShape)
                                    .background(Color.White.copy(alpha = 0.5f))
                            )

                            else -> {}
                        }
                    }
                }
            }
        }
    }
}

private fun shipImageFor(type: ShipType): DrawableResource = when (type) {
    ShipType.CARRIER -> Res.drawable.big_ship1
    ShipType.BATTLESHIP -> Res.drawable.big_ship2
    ShipType.CRUISER -> Res.drawable.med_ship1
    ShipType.SUBMARINE -> Res.drawable.med_ship2
    ShipType.DESTROYER -> Res.drawable.small_ship1
}

@Composable
fun SidePanel(
    score: Int,
    penalties: Int,
    correctAnswers: Int,
    shipsRemaining: Int,
    charges: AttackCharges,
    selectedAttack: AttackType,
    isMobile: Boolean,
    onForfeitClick: () -> Unit
) {
    Column(
        modifier = Modifier
            .widthIn(max = 320.dp)
            .fillMaxWidth()
            .background(Color.Black.copy(alpha = 0.5f), RoundedCornerShape(8.dp))
            .border(2.dp, Color.White.copy(alpha = 0.5f), RoundedCornerShape(8.dp))
            .padding(12.dp)
    ) {
        Text(
            text = "FLEET STATUS",
            color = Color.White,
            style = MaterialTheme.typography.titleMedium,
            fontWeight = FontWeight.Bold
        )
        Spacer(Modifier.height(12.dp))
        StatRow("Score", score.toString(), Color(0xFF00CFFF))
        StatRow("Penalties", penalties.toString(), Color(0xFFFF4444))
        StatRow("Intel Gathered", correctAnswers.toString(), Color(0xFF00FF00))
        StatRow("Enemy Cells Left", shipsRemaining.toString(), Color.Yellow)

        Spacer(Modifier.height(16.dp))
        Text("ARMAMENT", color = Color(0xFF00CFFF), fontWeight = FontWeight.Bold, fontSize = 12.sp)
        Spacer(Modifier.height(4.dp))

        AttackType.entries.forEach { type ->
            val count = charges.chargeFor(type)
            val label = if (type == AttackType.TORPEDO) "∞" else count.toString()
            val color = when {
                type == selectedAttack -> Color(0xFF00FF00)
                charges.canUse(type) -> Color.White
                else -> Color.Gray
            }
            Row(
                modifier = Modifier.fillMaxWidth().padding(vertical = 2.dp),
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Text(type.displayName, color = color, fontSize = 11.sp)
                Text(label, color = color, fontSize = 11.sp, fontWeight = FontWeight.Bold)
            }
        }


        Spacer(Modifier.height(12.dp))
        Text("ATTACK GUIDE", color = Color.White.copy(alpha = 0.7f), fontSize = 10.sp)
        Spacer(Modifier.height(4.dp))
        AttackType.entries.forEach { type ->
            Text(
                "• ${type.displayName}: ${type.description}",
                color = Color.White.copy(alpha = 0.6f),
                fontSize = 9.sp,
                modifier = Modifier.padding(vertical = 1.dp)
            )
        }
        Spacer(Modifier.height(16.dp))

        Button(
            modifier = Modifier.fillMaxWidth(),
            colors = ButtonDefaults.buttonColors(
                containerColor = Color(0xFFD32F2F)
            ),
            onClick = onForfeitClick
        ) {
            Text(
                "FORFEIT MATCH",
                fontWeight = FontWeight.Bold
            )
        }
    }
}

@Composable
fun StatRow(label: String, value: String, valueColor: Color) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(vertical = 3.dp),
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        Text(text = label, color = Color.White.copy(alpha = 0.8f), fontSize = 12.sp)
        Text(text = value, color = valueColor, fontWeight = FontWeight.Bold, fontSize = 12.sp)
    }
}

@Composable
fun EnemyTimerCard(
    opponentMode: TimerMode,
    opponentRemaining: Int
) {

    Surface(
        modifier = Modifier.wrapContentWidth(),
        color = Color(0xFF111827),
        border = BorderStroke(
            2.dp,
            Color(0xFFFF9800)
        ),
        shape = RoundedCornerShape(14.dp)
    ) {

        Column(
            modifier = Modifier.padding(
                horizontal = 20.dp,
                vertical = 12.dp
            ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Text(
                "ENEMY STATUS",
                color = Color(0xFFFF9800),
                fontWeight = FontWeight.Bold
            )

            Spacer(Modifier.height(6.dp))

            when (opponentMode) {

                TimerMode.TURN -> {

                    Text(
                        "Selecting Target",
                        color = Color.White
                    )

                    Spacer(Modifier.height(4.dp))

                    Text(
                        "${opponentRemaining}s",
                        color = Color.Cyan,
                        fontSize = 24.sp,
                        fontWeight = FontWeight.Bold
                    )
                }

                TimerMode.QUESTION -> {

                    Text(
                        "Answering Question",
                        color = Color.White
                    )

                    Spacer(Modifier.height(4.dp))

                    Text(
                        "${opponentRemaining}s",
                        color = Color.Yellow,
                        fontSize = 24.sp,
                        fontWeight = FontWeight.Bold
                    )
                }

                else -> {

                    Text(
                        "Waiting...",
                        color = Color.Gray
                    )
                }
            }
        }
    }
}
